import styled from 'styled-components';

export const ContentAction = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
`;

export const UpdatedAt = styled.span`
  ${(props) => props.theme.config.typograph.xsmall};
  color: ${(props) => props.theme.config.colors.gray_400};
`;

export const Cell = styled.div`
  display: flex;
  flex-direction: column;

  span:last-child {
    ${(props) => props.theme.config.typograph.xsmall};
    color: ${(props) => props.theme.config.colors.gray_400};
  }
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const Results = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: ${(props) => (props.$scrollable ? 'auto' : 'hidden')};
  transition: opacity 0.2s;

  &[aria-busy='true'] {
    opacity: 0.5;
  }
`;

export const Error = styled.p`
  padding: 2.4rem 0;
  text-align: center;
  ${(props) => props.theme.config.typograph.default};
  color: ${(props) => props.theme.config.colors.gray};
`;

// WidgetEmptyData is sized for a whole card; here it shares the card with the header actions.
export const EmptyState = styled.div`
  height: 100%;

  & > div {
    height: 100%;
  }
`;

export const Warning = styled.p`
  margin: 0;
  ${(props) => props.theme.config.typograph.xsmall};
  color: ${(props) => props.theme.config.colors.gray_400};

  &:not(:empty) {
    padding: 0.8rem 0;
  }
`;
